import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ActionItem } from '../action-item/entities/action-item.entity';
import { NavigationItem } from '../navigation-item/entities/navigation-item.entity';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ShActionItemComponent } from '../action-item/action-item.component';
import { ShIconModule } from '../icon/icon.module';
import { ShNavigationItemComponent } from '../navigation-item/navigation-item.component';
@Component({
    standalone: true,
    selector: 'sh-navigation',
    templateUrl: './navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule, CommonModule, ShIconModule, ShActionItemComponent, ShNavigationItemComponent]
})
export class ShNavigationComponent {
    @Input() mainActionItem!: ActionItem;
    @Input() primaryNavItems!: NavigationItem[];
    @Input() secondaryNavItems!: NavigationItem[];
}
